/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/* plugins/data-exporter/assets/js/data-exporter.js — export builder + preview + download. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["data-exporter"] = "1.0.3"; } catch (e) {}
  var META = { datasets: [], formats: [], presets: [], parquet: false };
  var SEL = { dataset: "pages", format: "csv", preset: "last_30_days", from: null, to: null, columns: null, device: "", country: "" };

  function q(k) { return document.querySelector('[data-dx="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function site() { return (window.GS && GS.site) || ""; }

  function fillSelect(el, items, valFn, labFn, cur) {
    if (!el) return;
    el.innerHTML = items.map(function (it) { var v = valFn(it); return '<option value="' + esc(v) + '"' + (v === cur ? " selected" : "") + '>' + esc(labFn(it)) + '</option>'; }).join("");
  }
  function currentCols() { var d = META.datasets.filter(function (x) { return x.key === SEL.dataset; })[0]; return d ? d.columns : []; }

  function buildColumns() {
    var host = q("columns"); if (!host) return;
    var cols = currentCols();
    host.innerHTML = cols.map(function (c) {
      return '<label class="dx-col"><input type="checkbox" data-dx-col value="' + esc(c) + '" checked> ' + esc(c) + '</label>';
    }).join("");
  }
  function selectedColumns() {
    var picked = [].slice.call(document.querySelectorAll('[data-dx-col]:checked')).map(function (c) { return c.value; });
    return picked.length ? picked : null;
  }

  function body() {
    return {
      dataset: SEL.dataset, format: SEL.format, date_preset: SEL.preset || null,
      date_start: SEL.from, date_end: SEL.to, columns: selectedColumns(),
      filters: { device: SEL.device || null, country: SEL.country || null },
      filename: (q("filename") || {}).value || "",
      bom: !!((q("opt-bom") || {}).checked), minify: !!((q("opt-minify") || {}).checked),
      create_table: !!((q("opt-createtable") || {}).checked)
    };
  }

  function preview() {
    if (!site()) return;
    var host = q("preview"); if (host) host.innerHTML = '<div class="dx-muted">Loading preview…</div>';
    GS.api("/plugin/data-exporter/preview?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(body()) }).then(function (r) {
      var d = r && r.data; if (!d || !d.ok) { if (host) host.innerHTML = '<div class="dx-muted">'+TR('dataex.no_preview')+'</div>'; return; }
      var lbl = q("range-label"); if (lbl && d.range) lbl.textContent = d.range.from + " → " + d.range.to;
      var cnt = q("count"); if (cnt) cnt.textContent = d.total + " rows";
      if (!d.rows.length) { host.innerHTML = '<div class="dx-muted">'+TR('dataex.f2.no_rows_in_this_range')+'</div>'; return; }
      var h = '<table class="dx-table"><thead><tr>' + d.columns.map(function (c) { return '<th>' + esc(c) + '</th>'; }).join("") + '</tr></thead><tbody>';
      h += d.rows.map(function (row) { return '<tr>' + d.columns.map(function (c) { return '<td>' + esc(row[c]) + '</td>'; }).join("") + '</tr>'; }).join("");
      host.innerHTML = h + '</tbody></table>' + (d.total > d.rows.length ? '<div class="dx-muted mt-2">Showing first ' + d.rows.length + ' of ' + d.total + '.</div>' : '');
    });
  }

  function download() {
    if (!site()) return;
    var btn = q("download"); if (btn) { btn.disabled = true; btn.dataset.t = btn.textContent; btn.textContent = TT('de.a.preparing'); }
    var pt = (window.GSUI && GSUI.progressToast) ? GSUI.progressToast(TT('de.a.preparing') || 'Preparing export\u2026') : { update:function(){}, done:function(){} };
    pt.update(TT('de.a.preparing') || 'Preparing export\u2026', 40);
    GS.api("/plugin/data-exporter/export?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(body()) }).then(function (r) {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.t || "Download"; }
      var d = r && r.data;
      if (!d || !d.ok) { pt.done((d && d.message) || "Export failed.", 'error'); var n = q("status"); if (n) n.textContent = (d && d.message) || "Export failed."; return; }
      var bin = atob(d.b64), len = bin.length, bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) bytes[i] = bin.charCodeAt(i);
      var blob = new Blob([bytes], { type: d.mime });
      var url = URL.createObjectURL(blob), a = document.createElement("a");
      a.href = url; a.download = d.filename; document.body.appendChild(a); a.click();
      setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 1000);
      pt.done((TR('dataex.g.downloaded') || 'Downloaded ') + d.filename, 'success');
      var n = q("status"); if (n) n.textContent = TR('dataex.g.downloaded') + d.filename + " (" + d.count + " rows).";
    });
  }

  function sendWebhook() {
    var url = (q("webhook-url") || {}).value || ""; if (!url) return;
    var n = q("webhook-status"); if (n) n.textContent = TT('de.a.sending');
    var b = body(); b.webhook_url = url; b.webhook_method = (q("webhook-method") || {}).value || "POST";
    GS.api("/plugin/data-exporter/webhook?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(b) }).then(function (r) {
      var d = r && r.data; if (n) n.textContent = (d && d.ok) ? ("Sent (HTTP " + d.status + ")") : ("Failed" + (d && d.status ? " (HTTP " + d.status + ")" : ""));
    });
  }

  function loadSettings() {
    GS.api("/plugin/data-exporter/settings?site=" + encodeURIComponent(site())).then(function (r) {
      var c = r && r.data && r.data.config; if (!c) return;
      if (c.default_format) { SEL.format = c.default_format; var fe = q("format"); if (fe) fe.value = c.default_format; var sf = q("set-format"); if (sf) sf.value = c.default_format; }
      if (c.default_preset) { SEL.preset = c.default_preset; var pe = q("preset"); if (pe) pe.value = c.default_preset; var sp = q("set-preset"); if (sp) sp.value = c.default_preset; var cw = q("custom-range"); if (cw) cw.hidden = !!c.default_preset; }
      preview();
    });
  }
  function saveSettings() {
    var b = { default_format: (q("set-format") || {}).value || "csv", default_preset: (q("set-preset") || {}).value || "last_30_days" };
    GS.api("/plugin/data-exporter/save-settings?site=" + encodeURIComponent(site()), { method: "POST", body: JSON.stringify(b) }).then(function (r) {
      var n = q("save-note"); if (n) { n.hidden = false; n.textContent = (r && r.data && r.data.ok) ? "Saved." : TR('dataex.g.save_failed'); setTimeout(function () { n.hidden = true; }, 1500); }
    });
  }
  function load() {
    GS.api("/plugin/data-exporter/datasets?site=" + encodeURIComponent(site())).then(function (r) {
      var d = r && r.data; if (!d || !d.ok) return;
      META = d;
      fillSelect(q("dataset"), d.datasets, function (x) { return x.key; }, function (x) { return x.label; }, SEL.dataset);
      var fmts = d.formats.filter(function (f) { return f !== "parquet" || d.parquet; });
      fillSelect(q("format"), fmts.map(function (f) { return { f: f }; }), function (x) { return x.f; }, function (x) { return x.f.toUpperCase(); }, SEL.format);
      fillSelect(q("preset"), [{ p: "" }].concat(d.presets.map(function (p) { return { p: p }; })), function (x) { return x.p; }, function (x) { return x.p ? x.p.replace(/_/g, " ") : TR('dataex.g.custom_range'); }, SEL.preset);
      buildColumns(); loadSettings();
    });
  }

  document.addEventListener("change", function (e) {
    var t = e.target, k = t && t.getAttribute && t.getAttribute("data-dx");
    if (k === "dataset") { SEL.dataset = t.value; buildColumns(); preview(); }
    else if (k === "format") { SEL.format = t.value; }
    else if (k === "preset") { SEL.preset = t.value; var cw = q("custom-range"); if (cw) cw.hidden = !!t.value; preview(); }
    else if (k === "from") { SEL.from = t.value; if (!SEL.preset) preview(); }
    else if (k === "to") { SEL.to = t.value; if (!SEL.preset) preview(); }
    else if (k === "device") { SEL.device = t.value; preview(); }
    else if (k === "country") { SEL.country = t.value; preview(); }
    else if (t && t.hasAttribute && t.hasAttribute("data-dx-col")) { preview(); }
  });
  document.addEventListener("click", function (e) {
    var t = e.target, k = t && t.closest && (t.closest("[data-dx-btn]") || {}).getAttribute && t.closest("[data-dx-btn]").getAttribute("data-dx-btn");
    if (k === "preview") preview();
    else if (k === "download") download();
    else if (k === "webhook") sendWebhook();
    else if (k === "save-settings") saveSettings();
  });
  document.addEventListener("gs:ready", function () { load(); });
  document.addEventListener("gs:site-change", function () { load(); });
  if (window.GS && GS.site) load();
})();
